import styled, { css } from 'styled-components';

import { spacing } from 'commons';

const WrapperButton_success = css`
  border-color: ${({ theme }) => theme.success_300};
`;

const WrapperButton_error = css`
  border-color: ${({ theme }) => theme.danger_500};
`;

const WrapperButton_status = {
  success: WrapperButton_success,
  error: WrapperButton_error,
  default: '',
};

export const WrapperButton = styled.button<{
  $status: 'default' | 'error' | 'success';
}>`
  display: flex;
  flex: 1;
  align-items: center;
  gap: 8px;
  height: inherit;
  padding: 0 16px;
  border: 1px solid ${({ theme }) => theme.neutral_500};
  border-radius: inherit;
  background-color: ${({ theme }) => theme.neutral_100};
  cursor: pointer;

  ${({ $status }) => WrapperButton_status[$status]}
`;

const Main_disabled = css`
  cursor: not-allowed;

  input {
    color: ${({ theme }) => theme.neutral_300};
  }

  ${WrapperButton} {
    pointer-events: none;
    border-color: ${({ theme }) => theme.neutral_300};
    background-color: ${({ theme }) => theme.neutral_200};
    color: ${({ theme }) => theme.neutral_300};
  }
`;

export const Main = styled.div<{ $disabled: boolean }>`
  position: relative;
  display: flex;
  flex: 1;
  min-height: ${spacing.input.height};
  max-height: ${spacing.input.height};
  border-radius: ${spacing.input.borderRadius};

  ${({ $disabled }) => $disabled && Main_disabled}
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  min-width: 24px;

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const Listbox = styled.div<{ $topPosition?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;
  max-height: 32vh;
  padding: 8px;
  border-radius: inherit;
  border: 1px solid ${({ theme }) => theme.neutral_300};
  background-color: ${({ theme }) => theme.neutral_100};
  box-shadow: 1px 3px 12px -4px ${({ theme }) => theme.neutral_300};
  z-index: 5;
`;

export const Option = styled.span<{ $hovered: boolean; $selected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  border-radius: 4px;
  background-color: transparent;
  gap: 12px;
  font-weight: 400;
  font-size: 12px;
  padding: 8px 12px;

  ${({ $hovered, theme }) =>
    $hovered && `outline: 1px solid ${theme.neutral_500};`}
  ${({ $selected, theme }) =>
    $selected && `background-color: ${theme.neutral_200};`}
`;
